/**************************************************
 * Nombre:       Formulario_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid2, IconButton, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {Delete, GifBoxOutlined, LocalOfferOutlined} from "@mui/icons-material";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../Servicios/BD/obtenerCol";
import IngresoSelectFuncion from "../../Modulo_formularios/Componentes/IngresoSelectFuncion";

const Formulario_Producto_SubCategoria = ({...props}) => {
    const [subCategorias, setSubCategorias] = useState([])
    const [subCats, setSubCats] = useState([])
    const [escogida, setEscogida] = useState({})

    const agregarCat = () => {

        props.props.setValue('subCategorias.' + subCats.length, escogida)

    }

    const borrarSubCat = (index) => {
        let arr = subCats
        arr.splice(index, 1)
        props.props.setValue('subCategorias', arr)
    }


    useEffect(() => {

        let arr = props.props.getValues('subCategorias') ? props.props.getValues('subCategorias') : []
        setSubCats(arr)

    }, [props.props.watch('subCategorias')]);

    useEffect(() => {
        obtenerCol('subCategorias').then((dox) => {
            if (dox.res) {
                setSubCategorias(dox.data.map((it) => it.nombre).sort())
            }
        })
    }, []);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid2
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={GifBoxOutlined} nombre={'Nombre del producto'}
                                  dato={'nombre'} {...props} editable={false}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Sub Categorias posee el producto</Typography>
                </Grid2>

                <Grid2 container size={8}>
                    <IngresoSelectFuncion Icono={LocalOfferOutlined} nombre={'Lista sub Categorias'}
                                          dato={'categoriaUltima'} {...props} setDato={setEscogida}
                                          opciones={subCategorias}
                    />
                </Grid2>

                <Grid2 container size={4} sx={{justifyContent: 'flex-end'}}>
                    <Button
                        onClick={() => agregarCat()}
                        variant={'outlined'}>Agregar</Button>
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>

                    <Grid2
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>


                        {subCats.map((it, index) => {
                            return (
                                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                                    <Grid2
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'center'}
                                        size={{xs: 12, sm: 12, md: 12}}
                                        sx={{borderBottom: 1, borderColor: '#00000050'}}
                                    >


                                        <Grid2 container size={10}>
                                            <Typography>{it}</Typography>
                                        </Grid2>

                                        <Grid2 container size={2} sx={{justifyContent: 'flex-end'}}>
                                            <IconButton
                                                onClick={() => borrarSubCat(index)}
                                            ><Delete/></IconButton>
                                        </Grid2>

                                    </Grid2>

                                </Grid2>
                            )
                        })}

                    </Grid2>


                </Grid2>


            </Grid2>

        </form>

    )

}
export default Formulario_Producto_SubCategoria